import * as React from "react";
import {
  Box,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  useTheme,
} from "@mui/material";
import BreadCrumbs from "../../components/Breadcrumbs";
import CommonForm from "./CommonForm";
import Rooms from "../../components/RoomFinder/RoomFinderSearch/Rooms";
import RequestOperations from "../../components/RoomFinder/RequestOperations/RequestOperations";
import NoDataFound from "../../components/NoDataFound";
import { setPageType } from "../../redux/actions/actions";
import { useDispatch } from "react-redux";
import StyledTitleDot from "../../components/common/StyledTitleDot";
import { useRoomFinder } from "../../contexts/RoomFinderContext";
import axiosInstance from "../../axiosInstance";
import BookingTheGap from "../../components/DashboardMain/BookingTheGap";
import { useTranslation } from "react-i18next";

// const rooms = [
//   {
//     course_id: 13,
//     course_name: "Paddington Citi View",
//     course_address: "15 - 25 Talbot Square, London, W2 1TT",
//     course_nearby_addresses: [
//       {
//         name: "University Of London",
//         distance: "0.1 Miles",
//       },
//       {
//         name: "Paddington Station",
//         distance: "0.3 Miles",
//       },
//       {
//         name: "Paddington College",
//         distance: "0.4 Miles",
//       },
//     ],
//     images: [PaddingtonImg],
//   },
//   {
//     course_id: 13,
//     course_name: "Drapery Place",
//     course_address: "65 Leman St, London E1 8EU",
//     course_nearby_addresses: [
//       {
//         name: "Brick Lane",
//         distance: "0.7 Miles",
//       },
//       {
//         name: "Tower of London",
//         distance: "1 Mile",
//       },
//       {
//         name: "The Whitechapel Gallery",
//         distance: "0.4 Miles",
//       },
//     ],
//     images: [DraperyImg],
//   },
//   {
//     course_id: 13,
//     course_name: "Lewisham Exchange",
//     course_address: "Exchange Point, Loampit Vale, London SE13 7NX",
//     course_nearby_addresses: [
//       {
//         name: "Lewisham College",
//         distance: "14 min walk",
//       },
//       {
//         name: "University of Greenwich",
//         distance: "12 mins by cycle",
//       },
//       {
//         name: "Goldsmiths University",
//         distance: "27 mins via tube",
//       },
//     ],
//     images: [LewishamImg],
//   },
// ];
export default function RoomFinder() {
  const initialState = {
    provider: "",
    universities: "",
    residences: "",
    occupancy: "",
    course: "",
    currency: "",
    numberOfStudents: "",
    additionalNote: "",
    checkIn: null,
    checkOut: null,
    refreshControl: true,
  };

  const theme = useTheme();

  const { t } = useTranslation();

  const [formValues, setFormValues] = React.useState(initialState);
  // const [availableRooms, setAvailableRooms] = React.useState(null);
  // const [selectedRooms, setSelectedRooms] = React.useState([]);
  const [loader, setLoader] = React.useState(false);
  const [loaderStart, setLoaderStart] = React.useState(false);
  const [bookingData, setBookingData] = React.useState({});
  const [roomControl, setRoomControl] = React.useState(true);

  const {
    selectedRooms,
    setSelectedRooms,
    availableRooms,
    setAvailableRooms,
    allRooms,
    setAllRooms,
    setSeeAvailableRoomNumber,
  } = useRoomFinder(); // Context'ten state ve setState fonksiyonlarını alıyoruz

  const availableRoomsRef = React.useRef(null); // Ref'i oluştur

  // React.useEffect(() => {
  //   console.log(bookingData, "booking data");
  // }, [bookingData]);

  const [accommodations, setAccommodations] = React.useState([]);
  const [, setFilteredAccommodations] = React.useState([]);
  const [, setLoading] = React.useState(true);
  const [, setError] = React.useState(null);

  const fetchData = async () => {
    try {
      setLoading(true);

      const params = new URLSearchParams();
      params.append("api_key", "O0AUQ0KLAD3I71K8YKR82Y6AP");

      const response = await axiosInstance.post(
        "https://webservice.londonist.co.uk/v1/DMCGetAvailableResidencesGAP",
        params,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );

      const processedData = processAccommodationData(response.data.result);
      setAccommodations(processedData);
      setLoading(false);
    } catch (err) {
      setError("Failed to fetch data. Please try again later.");
      setLoading(false);
      console.error("Error fetching data:", err);
    }
  };

  React.useEffect(() => {
    fetchData();

    // For demo purposes, we'll use the provided data directly
    const processedData = processAccommodationData(demoData);
    setAccommodations(processedData);
    setFilteredAccommodations(processedData);
    setLoading(false);

    // Uncomment this to fetch from actual API
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  console.log(accommodations, "accsss");
  const processAccommodationData = (data) => {
    const flattenedData = [];

    Object.keys(data).forEach((provider) => {
      Object.keys(data[provider]).forEach((propertyName) => {
        const property = data[provider][propertyName];

        Object.keys(property.room_types).forEach((roomTypeName) => {
          const roomType = property.room_types[roomTypeName];

          roomType.available_rooms.forEach((roomGroup) => {
            roomGroup.forEach((room) => {
              flattenedData.push({
                provider,
                propertyName: property.property_name,
                propertyAddress: property.property_address,
                nearByAdresses: property?.property_near_by_universities,
                propertyImage: property.property_image,
                propertyFacilities: property.property_facilities || [],
                propertyDescription: property.property_description || "",
                roomTypeName,
                roomKind: roomType.room_kind,
                roomImages: roomType.room_images,
                description: roomType.description,
                bedCount: roomType.bed_count,
                dailyPrice: Number.parseFloat(room.daily_price),
                normalDailyPrice: Number.parseFloat(room.normal_daily_price),
                totalPrice: Number.parseFloat(room.total_price),
                duration: Number.parseInt(room.duration),
                checkin: room.checkin,
                checkout: room.checkout,
                roomId: room.room_id,
              });
            });
          });
        });
      });
    });

    // En ucuz 3 odayı filtrele
    const sortedRooms = [...flattenedData].sort(
      (a, b) => a.dailyPrice - b.dailyPrice
    );
    const cheapestThree = sortedRooms.slice(0, 3);

    return cheapestThree;
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormValues((prev) => ({
      ...prev,
      refreshControl: false,
      [name]: value,
    }));
  };
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(setPageType("room_finder"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (availableRoomsRef.current) {
      const yOffset = -100; // 100px yukarıdan boşluk bırakmak için
      const y =
        availableRoomsRef.current.getBoundingClientRect().top +
        window.pageYOffset +
        yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  }, [availableRooms]);

  // React.useEffect(() => {
  //   console.log(selectedRooms, "selected rooms");
  // }, [selectedRooms]);
  //   const handleFindRooms = () => {
  //     //if (checkIn && checkOut) {
  //     const checkInDate = checkIn.format("YYYY-MM-DD");
  //     const checkOutDate = checkOut.format("YYYY-MM-DD");
  //     navigate(
  //       `/room-finder-results?checkin=${checkInDate}&checkout=${checkOutDate}`
  //     );
  //     //}
  //   };

  const [orderType, setOrderType] = React.useState("low-to-high");

  React.useEffect(() => {
    if (availableRooms?.length && !allRooms?.length) {
      Ordering("low-to-high");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [availableRooms, allRooms]);

  function Ordering(order_type) {
    let allRoomsTemp = [];
    const fixedRooms = availableRooms?.filter(
      (room) =>
        room.course_promotion_discount_amount &&
        room.course_promotion_discount_type === "fixed"
    );

    const percentageRooms = availableRooms?.filter(
      (room) =>
        room.course_promotion_discount_amount &&
        room.course_promotion_discount_type === "percentage"
    );

    const nonPromotionRooms = availableRooms?.filter(
      (room) => !room.course_promotion_discount_amount
    );

    if (fixedRooms?.length) {
      fixedRooms.forEach((room) => {
        allRoomsTemp.push({
          ...room,
          ordered_price:
            ((room?.duration / 7) * room?.price).toFixed(2) -
            room?.course_promotion_discount_amount,
        });
      });
    }

    if (percentageRooms?.length) {
      percentageRooms.forEach((room) => {
        allRoomsTemp.push({
          ...room,
          ordered_price: (
            (room?.duration / 7) * room?.price -
            room?.course_promotion_discount_amount
          ).toFixed(2),
        });
      });
    }

    if (nonPromotionRooms?.length) {
      nonPromotionRooms.forEach((room) => {
        allRoomsTemp.push({
          ...room,
          ordered_price: ((room?.duration / 7) * room?.price).toFixed(2),
        });
      });
    }

    // allRoomsTemp array'ini price değerine göre yüksekten düşüğe sıralayın
    if (order_type === "high-to-low") {
      allRoomsTemp.sort((a, b) => b.ordered_price - a.ordered_price);
    } else {
      allRoomsTemp.sort((a, b) => a.ordered_price - b.ordered_price);
    }

    // allRooms array'ini state'e kaydedin
    setAllRooms(allRoomsTemp);
  }

  const handleOrderChange = (e) => {
    setOrderType(e.target.value);
  };

  React.useEffect(() => {
    Ordering(orderType);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderType]);

  React.useEffect(() => {
    if (allRooms?.length) {
      setAvailableRooms(allRooms);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allRooms]);

  return (
    <>
      {loaderStart ? (
        <CircularProgress
          sx={{
            position: "fixed",
            top: "calc(50% - 20px)",
            left: "calc(50% - 20px)",
            zIndex: "999999",
          }}
        />
      ) : null}
      <Typography textTransform={"capitalize"} className="title" variant="h4">
        {t("roomFinder")}
        <StyledTitleDot />
      </Typography>
      <BreadCrumbs routs={[t("roomFinder")]} />
      <CommonForm
        formValues={formValues}
        setFormValues={setFormValues}
        handleChange={handleChange}
        availableRooms={availableRooms}
        setAvailableRooms={setAvailableRooms}
        availableRoomsRef={availableRoomsRef}
        setLoader={setLoader}
        initialState={initialState}
        setSelectedRooms={setSelectedRooms}
        setOrderType={setOrderType}
        setAllRooms={setAllRooms}
        roomControl={roomControl}
        setRoomControl={setRoomControl}
        setSeeAvailableRoomNumber={setSeeAvailableRoomNumber}
      />
      <Box
        ref={availableRoomsRef}
        sx={{ display: "flex", flexDirection: "column", paddingBottom: "3rem" }}
      >
        {!loader ? (
          availableRooms?.length ? (
            <>
              <FormControl sx={{ marginLeft: "auto" }}>
                <InputLabel id="demo-simple-select-label">
                  {t("orderByPrice")}
                </InputLabel>
                <Select
                  sx={{ textTransform: 'capitalize' }}
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={orderType}
                  label={t("orderByPrice")}
                  onChange={handleOrderChange}
                >
                  <MenuItem
                    sx={{ textTransform: 'capitalize' }}
                    value={"high-to-low"}>{t("highToLow")}</MenuItem>
                  <MenuItem
                    sx={{ textTransform: 'capitalize' }}
                    value={"low-to-high"}>{t("lowToHigh")}</MenuItem>
                </Select>
              </FormControl>

              {availableRooms?.map((availableRoom, idx) => {
                return (
                  <Rooms
                    key={idx}
                    data={availableRoom}
                    formValues={formValues}
                    selectedRooms={selectedRooms}
                    setSelectedRooms={setSelectedRooms}
                    bookingData={bookingData}
                    setBookingData={setBookingData}
                  />
                );
              })}
            </>
          ) : // Eğer 1 saniye geçtiyse NoDataFound'u göster
            !roomControl ? (
              <NoDataFound />
            ) : null
        ) : (
          <CircularProgress
            sx={{
              position: "fixed",
              top: "50%",
              left: "50%",
              zIndex: "9999999999999",
            }}
          />
        )}
      </Box>

      <Box
        display={"flex"}
        justifyContent={"space-between"}
        width={"100%"}
        mb={3}
      >
        <Typography
          variant="h4"
          fontWeight={700}
          color={theme.palette.customRed.orange}
        >
          {t("specialOffersForYou")}
        </Typography>
        {/* <Button
          target="_blank"
          size="small"
          href="/special-offers"
          variant="outlined"
          color="primary"
        >
          See All Accommodations
        </Button> */}
      </Box>
      <Grid container spacing={3}>
        <BookingTheGap type={"non-carousel"} />
        {accommodations?.map((room, idx) => {
          return null;
          // <Grid key={idx} item xs={12} lg={4}>
          //   <Box
          //     sx={{
          //       height: "100%",
          //       maxHeight: 440,
          //       cursor: "pointer",
          //       boxShadow: `0 0 3px ${lightMode ? `#d8d8d8` : `#d8d8d8`}`,
          //       background: lightMode ? `#ffffff` : `#191919`,
          //       padding: "1rem",
          //       marginBottom: "1rem",
          //       borderRadius: "2rem",
          //       display: "flex",
          //       flexDirection: "column",
          //       justifyContent: "center",
          //       alignItems: "center",
          //       "&:hover": {
          //         boxShadow: `0 0 3px ${
          //           lightMode ? `${theme.palette.primary.main}` : `#292929`
          //         }`,
          //         img: {
          //           transition: "transform .35s",
          //           transform: "scale(1.1)",
          //         },
          //       },
          //     }}
          //   >
          //     <Box
          //       sx={{
          //         height: "270px",
          //         width: "100%",
          //         minWidth: "150px",
          //         borderRadius: "1rem",
          //         overflow: "hidden",
          //       }}
          //     >
          //       <img
          //         src={
          //           room?.propertyImage && room?.propertyImage?.length
          //             ? room?.propertyImage[0]
          //             : NoImageFound
          //         }
          //         alt=""
          //         style={{
          //           transition: "transform .35s",
          //           objectFit: "cover",
          //           objectPosition: "center",
          //           width: "100%",
          //           height: "100%",
          //         }}
          //       />
          //     </Box>
          //     <Box
          //       sx={{
          //         display: "flex",
          //         padding: "1rem",
          //         flexDirection: "column",
          //         minHeight: "100px",
          //         height: "100%",
          //         width: "100%",
          //       }}
          //     >
          //       <Box display={"flex"} alignItems={"center"}>
          //         <img src={LocationIconImg} alt="" />

          //         <Typography
          //           variant="h6"
          //           fontWeight={700}
          //           ml={1}
          //           color={theme.palette.primary.main}
          //         >
          //           {room.propertyName}
          //         </Typography>
          //       </Box>
          //       <Typography
          //         sx={{
          //           display: "-webkit-box" /* or inline-block */,
          //           textOverflow: "ellipsis",
          //           wordWrap: "break-word",
          //           WebkitLineClamp: 2,
          //           WebkitBoxOrient: "vertical",
          //           overflow: "hidden",
          //           lineHeight: "1.8em",
          //         }}
          //         color={theme.palette.primary.main}
          //         variant="caption"
          //         mb={3}
          //         mt={1}
          //       >
          //         {room.propertyAddress}
          //       </Typography>
          //       {room?.nearByAdresses?.length ? (
          //         <Box sx={{ maxHeight: "100px", overflow: "auto" }}>
          //           {room?.nearByAdresses?.map((address, idx) => {
          //             return (
          //               <Box
          //                 display={"flex"}
          //                 flexDirection={"row"}
          //                 justifyContent={"space-between"}
          //               >
          //                 <Typography
          //                   color={theme.palette.primary.main}
          //                   variant="caption"
          //                 >
          //                   {address?.university_title}
          //                 </Typography>
          //                 <Typography
          //                   color={theme.palette.primary.main}
          //                   variant="caption"
          //                 >
          //                   {address?.distance}
          //                 </Typography>
          //               </Box>
          //             );
          //           })}
          //         </Box>
          //       ) : null}
          //     </Box>
          //   </Box>
          // </Grid>
        })}
      </Grid>
      {selectedRooms.length ? (
        <RequestOperations
          selectedRooms={selectedRooms}
          setSelectedRooms={setSelectedRooms}
          bookingData={bookingData}
          setBookingData={setBookingData}
          setLoaderStart={setLoaderStart}
        />
      ) : null}
    </>
  );
}

// This is just for demo purposes - in a real app, you'd fetch this from the API
const demoData = {
  // The API response data would be used here
};
